import { jsx } from "react/jsx-runtime";
import { AllCommunityModule, ModuleRegistry, themeQuartz } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { Spin } from "antd";
import { forwardRef } from "react";
import empty from "../empty/index.js";
ModuleRegistry.registerModules([
    AllCommunityModule
]);
const myTheme = themeQuartz.withParams({
    accentColor: '#2166FF',
    borderColor: '#E5EAF0',
    browserColorScheme: 'light',
    cellTextColor: '#1D2129',
    foregroundColor: '#181F1B',
    headerBackgroundColor: '#F7F8FA',
    headerColumnResizeHandleHeight: '100%',
    headerColumnResizeHandleWidth: 1,
    headerFontSize: 13,
    headerFontWeight: 600,
    headerTextColor: '#1D2129',
    rowHoverColor: '#F7F8FA',
    selectedRowBackgroundColor: '#EDF6FF',
    headerColumnResizeHandleColor: 'rgba(0,0,0,0)',
    headerColumnBorder: {
        style: 'solid',
        width: 1,
        color: '#E5EAF0'
    }
});
const loadingOverlayComponent = ()=>/*#__PURE__*/ jsx(Spin, {});
const emptyOverlayComponent = ()=>/*#__PURE__*/ jsx(empty, {});
function EEGridInner(props, ref) {
    return /*#__PURE__*/ jsx(AgGridReact, {
        ref: ref,
        theme: myTheme,
        noRowsOverlayComponent: emptyOverlayComponent,
        loadingOverlayComponent: loadingOverlayComponent,
        ...props
    });
}
const ee_grid = /*#__PURE__*/ forwardRef(EEGridInner);
export { ee_grid as default };
